<template>
  <i-modal :title="LANG.rootCatTitle" v-model:show="showModal">
    {{{
      [BrowserMode.DOC]: LANG.rootCatMissing,
      [BrowserMode.MAM]: LANG.rootCatMissingMam,
    }[browserMode]}}

    <p v-if="user.isSuperuser">
      {{{
        [BrowserMode.DOC]: LANG.rootCatCreate,
        [BrowserMode.MAM]: LANG.rootCatCreateMam,
      }[browserMode]}}
    </p>

    <template #footer>
      <div v-if="user.isSuperuser">
        <i-button variant="secondary" @click.prevent="close">{{ LANG.cancel }}</i-button>
        <i-button variant="primary" @click.prevent="confirm">{{ LANG.ok }}</i-button>
      </div>
      <div v-else>
        <i-button variant="primary" @click.prevent="close">{{ LANG.ok }}</i-button>
      </div>
    </template>
  </i-modal>
</template>

<script>
import { mapState } from 'vuex';
import { BrowserMode, TreeMode } from '@/store/modules/entity_browser/config';
import { mapBrowserState, mapBrowserGetters } from '@/store';
import { Status } from '@/utils/useData';

export default {
  data() {
    return {
      showModal: false,
      BrowserMode,
    };
  },
  computed: {
    ...mapState(['LANG', 'user', 'browserMode']),
    ...mapBrowserState(['treeMode']),
    ...mapBrowserGetters(['treeNodes', 'treeStatus']),
    isRootCategoryMissing() {
      return (
        this.treeMode === TreeMode.CATEGORY
        && this.treeStatus === Status.RESOLVED
        && !this.treeNodes.length
      );
    },
  },
  watch: {
    isRootCategoryMissing(v) {
      this.showModal = v;
    },
  },
  methods: {
    close() {
      this.showModal = false;
    },
    confirm() {
      this.$router.push({
        path: '/structure/new_edit',
        query: {
          new: '',
          ...(this.browserMode === BrowserMode.MAM && { ac_enabled_cb_helper: 1 }),
          // TODO: the `backto` option doesn't make sense
          // once we switch to a real router
          // the `back` button might call $router.back() / $router.go(-1) when needed
          backto: document.location.pathname + document.location.search,
        },
      });
    },
  },
};
</script>
